import React from "react";
import { Card, CardBody } from "reactstrap";
import CptShimmerBlock from "../CptShimmerBlock";

const PatientTableRowShimmer = ({ withFailedColumn = false }) => (
  <div className={`mpr-shimmer-patient-row${withFailedColumn ? " mpr-shimmer-patient-row--extended" : ""}`}>
    <div className="mpr-shimmer-cell-profile">
      <CptShimmerBlock className="mpr-shimmer-avatar" />
      <div className="mpr-shimmer-cell-lines">
        <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--md" />
        <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--sm" />
      </div>
    </div>
    <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--sm" />
    {withFailedColumn && <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--badge" />}
    <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--action" />
  </div>
);

const PatientListPanelShimmer = ({ rowCount = 6, embedded = false, withFailedColumn = false }) => {
  const body = (
    <>
      <div className="chart-header-modern mpr-shimmer-header-row">
        <CptShimmerBlock className="mpr-shimmer-icon-block" />
        <div className="chart-header-copy-modern">
          <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--title" />
          <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--subtitle" />
        </div>
      </div>
      <div className="mpr-shimmer-toolbar patient-list-toolbar">
        <CptShimmerBlock className="mpr-shimmer-search" />
        <CptShimmerBlock className="mpr-shimmer-export" />
      </div>
      {Array.from({ length: rowCount }).map((_, index) => (
        <PatientTableRowShimmer key={index} withFailedColumn={withFailedColumn} />
      ))}
    </>
  );

  if (embedded) {
    return <div className="mpr-shimmer-list-embedded">{body}</div>;
  }

  return (
    <Card className="mpr-patient-list-section mpr-shimmer-shell-card">
      <CardBody>{body}</CardBody>
    </Card>
  );
};

export default PatientListPanelShimmer;
